import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import useLenis from "@/hooks/useLenis";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Manifesto } from "@/components/Manifesto";
import { Films } from "@/components/Films";
import { Portrait } from "@/components/Portrait";
import { Contact } from "@/components/Contact";
import Preview from "@/pages/Preview";

const A24Portfolio = () => {
  useLenis();
  return (
    <div data-testid="a24-root" className="bg-bg text-ink min-h-screen">
      <Nav />
      <main>
        <Hero />
        <Manifesto />
        <Films />
        <Portrait />
        <Contact />
      </main>
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Preview />} />
          <Route path="/a24" element={<A24Portfolio />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
